import { render, staticRenderFns } from "./ShopIndex.vue?vue&type=template&id=6a1639b1&scoped=true&"
import script from "./ShopIndex.vue?vue&type=script&lang=js&"
export * from "./ShopIndex.vue?vue&type=script&lang=js&"
import style0 from "./ShopIndex.vue?vue&type=style&index=0&id=6a1639b1&scoped=true&lang=css&"
import style1 from "./ShopIndex.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1639b1",
  null
  
)

export default component.exports